<template>
  <div>
    <material-button
      class="d-none show-modal-choose-connect-option"
      data-bs-toggle="modal"
      data-bs-target="#modalChooseConnectOption"
    ></material-button>
    <material-button
      class="d-none hide-modal-choose-connect-option"
      data-bs-dismiss="modal"
      data-bs-target="#modalChooseConnectOption"
    ></material-button>
    <div
      class="modal fade"
      id="modalChooseConnectOption"
      tabindex="-1"
      aria-hidden="true"
      ref="modalChooseConnectOption"
      style="z-index: 9999"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content" style="width: unset">
          <div class="modal-body" style="overflow-y: unset">
            <div class="d-flex justify-content-between align-items-center">
              <h5 class="modal-title">Choose an option</h5>
              <i
                style="cursor: pointer"
                class="material-icons btn-close-modal justify-content-end"
                data-bs-dismiss="modal"
                aria-label="Close"
                >clear</i
              >
            </div>
            <div
              class="row mx-auto justify-content-center"
              style="width: max-content"
            >
              <div class="content col-lg-6 col-12" @click="getLinkConnect()">
                <div>
                  <h5>New Account</h5>
                  <i class="material-icons css-icon-menubook">edit</i>
                </div>
              </div>
              <div
                class="content col-lg-6 col-12"
                @click="connectExistingAccount()"
              >
                <div>
                  <h5>Existing Account</h5>
                  <i class="material-icons css-icon">credit_score</i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";

export default {
  name: "modal-choose-connect-option",
  components: {
    MaterialButton,
  },
  props: {
    getLinkConnect: {
      type: Function,
      default: () => {},
    },
    connectExistingAccount: {
      type: Function,
      default: () => {},
    },
  },
};
</script>

<style scoped>
.modal-body {
  max-height: 75vh;
  overflow-y: auto;
  padding-bottom: 25px;
}
.content {
  cursor: pointer;
  text-align: center;
  width: 250px;
  height: 250px;
  margin-top: 25px;
  border: 1px solid #ccc;
  margin-left: 10px;
  margin-right: 10px;
  background-color: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.css-icon {
  font-size: 50px !important;
}
.css-icon-menubook {
  position: relative;
  font-size: 50px !important;
}
.font-18 {
  font-size: 18px;
}
.mt-content {
  margin-top: 5rem;
}
@media (max-width: 500px) {
  .row {
    width: unset !important;
  }
  .content {
    width: 200px;
    height: 200px;
  }
}
</style>
